exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".groupTitle[data-v-3e94c2ce]{border-bottom:1px solid #ebeef5;color:#606266;font-size:16px;line-height:50px;font-weight:600}", ""]);

// exports
